import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import { Avatar, Box, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

function getInitials(playerName) {
  return playerName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}

function ProfileScreen({ playerName, onNavigate, onSavePlayerName }) {
  const [draftPlayerName, setDraftPlayerName] = useState(playerName);
  const [hasSaved, setHasSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState('');
  const hasNameChanges = draftPlayerName.trim() !== playerName;

  useEffect(() => {
    setDraftPlayerName(playerName);
  }, [playerName]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setSaveError('');

    try {
      await onSavePlayerName(draftPlayerName);
      setHasSaved(true);
    } catch (error) {
      setSaveError(error.message);
    } finally {
      setSaving(false);
    }
  };

  const handleNameChange = (event) => {
    setDraftPlayerName(event.target.value);
    setHasSaved(false);
    setSaveError('');
  };

  return (
    <Box className="screen">
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Box>
          <Typography variant="overline" color="text.secondary">
            Local profile
          </Typography>
          <Typography variant="h2">Profile</Typography>
        </Box>

        <Card>
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="center">
              <Avatar sx={{ width: 64, height: 64, bgcolor: 'primary.main', color: 'background.default' }}>
                {getInitials(playerName)}
              </Avatar>
              <Box>
                <Typography fontWeight={900}>{playerName}</Typography>
                <Typography color="text.secondary">Anonymous local player</Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <Box component="form" onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <TextField
                  value={draftPlayerName}
                  onChange={handleNameChange}
                  label="Player name"
                  inputProps={{ maxLength: 32 }}
                  fullWidth
                />
                <Button
                  type="submit"
                  variant="outlined"
                  startIcon={hasSaved && !hasNameChanges ? <CheckRoundedIcon /> : <SaveRoundedIcon />}
                  disabled={!hasNameChanges || saving}
                >
                  {saving ? 'Saving' : hasSaved && !hasNameChanges ? 'Saved' : 'Save Name'}
                </Button>
                {saveError && <Typography color="error">{saveError}</Typography>}
              </Stack>
            </Box>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
}

export default ProfileScreen;
